import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import linuxIcon from '../../../img/svg/Linux.svg';
import macIcon from '../../../img/svg/Mac.svg';
import windowsIcon from '../../../img/svg/Windows.svg';

function DownloadComponent(props) {
  // STATES
  const { value } = props;
  const [fileName, setFileName] = useState('');
  const [fileSize, setFileSize] = useState('');
  const [currentOperatingSystem, setCurrentOperatingSystem] = useState(windowsIcon);
  const [playableInBrowser, setPlayableInBrowser] = useState(false);

  // FUNCTIONS
  /*
    --------------------
    Formatiere Dateiname
    --------------------
    */
  function cutFileName(currentPath) {
    const result = currentPath.substring(currentPath.lastIndexOf('/') + 1);
    setFileName(result);
  }

  /*
    -------------------------------
    Setze je nach ID Betriebssystem
    -------------------------------
    */
  function setOperatingSystem(currentPath) {
    const tempOperatingSystem = currentPath.substring(
      currentPath.length - 9,
      currentPath.length - 4,
    );

    if (tempOperatingSystem.localeCompare('win64') === 0) {
      setCurrentOperatingSystem(windowsIcon);
    } else if (tempOperatingSystem.localeCompare('macOS') === 0) {
      setCurrentOperatingSystem(macIcon);
    } else if (tempOperatingSystem.localeCompare('linux') === 0) {
      setCurrentOperatingSystem(linuxIcon);
    } else {
      setCurrentOperatingSystem(windowsIcon);
    }
  }

  /*
    -------------------------------
    Prüfe, ob Spiel im Web spielbar
    -------------------------------
    */
  function isThereWeb(currentPath) {
    const tempIsWebZip = currentPath.substring(
      currentPath.length - 7,
      currentPath.length - 4,
    );

    if (tempIsWebZip.localeCompare('web') === 0) {
      setPlayableInBrowser(true);
    } else {
      setPlayableInBrowser(false);
    }
  }

  /*
    --------------------------------------------------------
    erzeugt das passende Format für die Download Information
    --------------------------------------------------------
    */
  // eslint-disable-next-line consistent-return
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    // eslint-disable-next-line no-restricted-properties
    setFileSize(`${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`);
  }

  // EFFECTS
  useEffect(() => {
    setOperatingSystem(value.file_name);
    isThereWeb(value.file_name);
    cutFileName(value.file_name);
    formatBytes(value.file_size);
  }, [value]);

  // RENDER
  return (
    <div key={value} className="OperatingSystemButtonContainer">
      {playableInBrowser === false ? (
        <>
          <a
            download
            href={`https://www.hdm-stuttgart.de/mediathek/${value.file_name}`}
          >
            <img
              style={{ opacity: '70%' }}
              className="OperatingSystemButton"
              src={currentOperatingSystem}
              alt={`Link zum Download: ${value.file_name}`}
              width="100%"
            />
            <p style={{ color: 'black' }}>{fileName}</p>
          </a>
          <p>{fileSize}</p>
        </>
      ) : null}
    </div>
  );
}

export default DownloadComponent;

DownloadComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any.isRequired,
};
